import { useNavigate } from "react-router-dom";
import { useModal } from "effects";
import { TCaseScanner } from "types";
import { SecondaryButton } from "components/Buttons";
import StageHeader from "components/StageHeader";
import { CreateCaseScannerModal, CaseScannersTable } from "components/shared";
import PageStage from "components/stages/PageStage";

export const CaseScannersPage = () => {
  const navigate = useNavigate();
  const { openModal } = useModal();

  const createCaseScanner = () => {
    openModal(
      <CreateCaseScannerModal
        onSuccess={(entity: TCaseScanner) => {
          navigate(`/apps/storage/case_scanners/${entity.id}`);
        }}
      />,
    );
  };

  return (
    <PageStage>
      <StageHeader
        title="Case scanners"
        subtitle="Manage your case scanners."
        action={
          <SecondaryButton icon="/images/icons/plus_1.svg" onClick={createCaseScanner}>
            Create case scanner
          </SecondaryButton>
        }
      />
      <CaseScannersTable />
    </PageStage>
  );
};
